<template>
  <d-modal
    @close="handleClose"
    size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settlementsHistoryPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 200px">{{ $t('settlementsHistoryPopup.createdAt') }}</th>
            <th>{{ $t('settlementsHistoryPopup.operation') }}</th>
            <th style="width: 200px">{{ $t('settlementsHistoryPopup.user') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(operation, index) of items"
            :key="'operation-log-' + index">
            <td>{{ operation.created_at }}</td>
            <td>{{ $t('settlementsHistoryPopup.operations.' + operation.action) }}</td>
            <td>{{ operation.user_name }}</td>
          </tr>
          <tr v-if="!loadedData">
            <td colspan="3">
              <d-alert
                :show="true"
                theme="light"
                class="text-center">
                {{ $t('ui.dataLoading') }}
              </d-alert>
            </td>
          </tr>
          <tr v-if="loadedData && !items.length">
            <td colspan="3">
              <d-alert
                :show="true"
                theme="warning"
                class="text-center">
                {{ $t('settlementsHistoryPopup.noOperations') }}
              </d-alert>
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-auto mr-auto"
        theme="danger"
        :outline="true"
        @click.prevent="cancel">
        {{ $t('ui.close') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'settlements-history-popup',
  props: [
    'settlementID'
  ],
  data () {
    return {
      loadError: false,
      loadedData: false,
      items: []
    };
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      endpoint: '/settlements/statuses/items?where[settlement_id]=' + this.settlementID,
      loadedKey: 'loadedData',
      errorKey: 'loadError',
      outputKey: 'items'
    });
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-settlement-history-popup');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
